import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { auth } from "../services/firebase";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const userUid = user?.uid;
  const [isAdmin, setIsAdmin] = React.useState<boolean | null>(null);
  React.useEffect(() => {
    let active = true;
    setIsAdmin(null);
    if (userUid && auth.currentUser)
      auth.currentUser
        .getIdTokenResult(true)
        .then((result) => {
          if (active) setIsAdmin(result.claims.isAdmin === true);
        })
        .catch(() => {
          if (active) setIsAdmin(false);
        });
    return () => {
      active = false;
    };
  }, [userUid]);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "18px",
          color: "#666",
        }}
      >
        Loading...
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (isAdmin === null)
    return <p role="status">Checking administrator access…</p>;
  if (!isAdmin)
    return (
      <p role="alert">
        This account does not have administrator permission. Contact the site
        owner.
      </p>
    );
  return <>{children}</>;
};

export default ProtectedRoute;
